module.exports = __webpack_public_path__ + "assets/forwardArrow.a54a1c40.svg";